import { deletePost } from "../../api/historyService";

export const useDeletePost = (successCallback) => {
    const remove = async (id) => {
        try {
            await deletePost(id);
            successCallback();
        } catch (error) {
            console.error("Failed to delete post:", error);
            throw error;
        }
    };

    return { remove };
};